<button
  type="button"
  class="pp-btn drc-trigger"
  [disabled]="disabled"
  [attr.aria-haspopup]="'dialog'"
  (click)="toggle($event)">
  <i class="pi pi-calendar" aria-hidden="true"></i>
  <span class="drc-trigger__label">{{ label }}</span>
  <i class="pi pi-chevron-down drc-trigger__caret" aria-hidden="true"></i>
</button>

<p-overlayPanel #op styleClass="drc-overlay" appendTo="body" (onShow)="onShow()" (onHide)="onHide()">
  <ng-template pTemplate="content">
    <div class="drc" role="dialog" aria-label="Choose a date range">
      <div class="drc__presets" *ngIf="presets.length">
        <button
          *ngFor="let p of presets"
          type="button"
          class="drc__preset"
          [class.is-active]="isPresetActive(p)"
          (click)="applyPreset(p)">
          {{ presetLabels[p] }}
        </button>
      </div>

      <div class="drc__cal">
        <div class="drc__nav">
          <button type="button" class="drc__nav-btn" aria-label="Previous month" (click)="shiftMonth(-1)">
            <i class="pi pi-chevron-left"></i>
          </button>
          <span class="drc__month">{{ monthLabel }}</span>
          <button type="button" class="drc__nav-btn" aria-label="Next month" (click)="shiftMonth(1)">
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>

        <div class="drc__weekdays" aria-hidden="true">
          <span *ngFor="let w of weekdayLabels">{{ w }}</span>
        </div>

        <div
          #grid
          class="drc__grid"
          role="grid"
          (pointermove)="onPointerMove($event)"
          (keydown)="onKeydown($event)">
          <button
            *ngFor="let d of days; trackBy: trackDay"
            type="button"
            class="drc__day"
            role="gridcell"
            [attr.data-day]="d.key"
            [attr.tabindex]="d.key === focusKey ? 0 : -1"
            [attr.aria-label]="d.date | date: 'EEEE d MMMM y'"
            [attr.aria-selected]="dayClasses(d)['is-in']"
            [ngClass]="dayClasses(d)"
            (pointerdown)="onPointerDown(d, $event)">
            <span>{{ d.date.getDate() }}</span>
          </button>
        </div>

        <div class="drc__foot" [class.is-pending]="pendingEnd">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>{{ previewLabel }}</span>
        </div>
        <div class="drc__limit" *ngIf="maxDays">Up to {{ maxDays }} days</div>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
